import { render, staticRenderFns } from "./DefaultConfig.vue?vue&type=template&id=d445a1a2&"
import script from "./DefaultConfig.vue?vue&type=script&lang=js&"
export * from "./DefaultConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports